export default "__VITE_ASSET__26f6a9c9__"